interface Props {
  name: string
  shortDescription: string | null
  tip: string | null
}

export function CuratedPlaceSlide({ name, shortDescription, tip }: Props) {
  return (
    <div className="tv-curated-place">
      <h2 className="tv-curated-place__name">{name}</h2>
      {shortDescription && (
        <p className="tv-curated-place__desc">{shortDescription}</p>
      )}
      {tip && (
        <p className="tv-curated-place__tip">
          <span className="tv-curated-place__tip-label">Tip</span> {tip}
        </p>
      )}
    </div>
  )
}
